import React from "react";
import { FaBus, FaClock, FaRoute } from "react-icons/fa"; // Add React Icons for visual appeal
import {
  MapContainer,
  TileLayer,
  Marker,
  Polyline,
  Popup,
} from "react-leaflet";
import L from "leaflet";
import "leaflet-routing-machine";
import "leaflet/dist/leaflet.css";
import { convertToAMPM } from "../../utilities";
import { useMap } from "react-leaflet";
import busstop from "../../Images/busstop.png";
import { useState, useEffect, useRef } from "react";
import busdrop from "../../Images/busdrop1.png";
import buspickup from "../../Images/bus3.png";
import unknownbus from "../../Images/busdrop.png";
import { FiMaximize, FiMinimize } from "react-icons/fi";
import { TbZoomScan } from "react-icons/tb";
const pickupIcon = L.divIcon({
  className: "custom-bus-icon pickup",
  iconSize: [35, 35],
  iconAnchor: [17.5, 17.5],
  html: `<img src="${buspickup}" style="width:35px;height:35px;" />`,
});
const dropoffIcon = L.divIcon({
  className: "custom-bus-icon dropoff",
  iconSize: [35, 35],
  iconAnchor: [17.5, 17.5],
  html: `<img src="${busdrop}" style="width:35px;height:35px;" />`,
});
const unknownicon = L.divIcon({
  className: "custom-bus-icon dropoff",
  iconSize: [35, 35],
  iconAnchor: [17.5, 17.5],
  html: `<img src="${unknownbus}" style="width:35px;height:35px;" />`,
});
const getStopIcon = L.icon({
  iconUrl: busstop,
  iconSize: [35, 35],
  iconAnchor: [17, 35],
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
  shadowSize: [41, 41],
  shadowAnchor: [13, 41],
});
const Trackmap = ({
  param,
  selectedbus,
  selectedroute,
  allRoutes,
  allStops,
  allBusses,
}) => {
  const mapRef = useRef();
  const [isFullscreen, setIsFullscreen] = useState(false);
  const containerRef = useRef(null);
  const busRefs = useRef({});
  const animationRefs = useRef({});
  const firstLoadRef = useRef(true);
  const lastUpdateTimes = useRef({});
  const [route, setRoute] = useState([]);
  const [stop, setStop] = useState([]);
  const [bus, setBus] = useState([]);
  const [filteredRoute, setFilteredRoute] = useState([]);
  const [filteredBus, setFilteredBus] = useState([]);
  const [filteredStops, setFilteredStop] = useState([]);
  const [mapInitialized, setMapInitialized] = useState(false);
  useEffect(() => {
    setStop(allStops);
    setBus(allBusses);
    setRoute(allRoutes);
  }, [allRoutes, allBusses, allStops]);

  const MapInitializer = ({ onMapReady }) => {
    const map = useMap();
    useEffect(() => {
      if (map) {
        onMapReady(map);
      }
    }, [map]);
    return null;
  };

  const toggleFullscreen = () => {
    const element = containerRef.current;
    if (!document.fullscreenElement) {
      element.requestFullscreen().then(() => {
        setIsFullscreen(true);
        setTimeout(() => {
          mapRef.current?.invalidateSize();
        }, 300);
      });
    } else {
      document.exitFullscreen().then(() => {
        setIsFullscreen(false);
        setTimeout(() => {
          mapRef.current?.invalidateSize();
        }, 300);
      });
    }
  };
  const animateMarker = (from, to, ref, duration = 1000, busId) => {
    return new Promise((resolve) => {
      if (!ref) return resolve();
      if (animationRefs[busId]) {
        cancelAnimationFrame(animationRefs[busId]);
      }
      const start = performance.now();
      const step = (now) => {
        const progress = Math.min((now - start) / duration, 1);
        const lat = from.lat + (to[0] - from.lat) * progress;
        const lng = from.lng + (to[1] - from.lng) * progress;
        ref.setLatLng([lat, lng]);
        if (progress < 1) {
          animationRefs[busId] = requestAnimationFrame(step);
        } else {
          delete animationRefs[busId]; // clean up here
          resolve();
        }
      };
      animationRefs[busId] = requestAnimationFrame(step);
    });
  };
  const isSignificantChange = (from, to, threshold = 0.00005) => {
    return (
      Math.abs(from.lat - to[0]) > threshold ||
      Math.abs(from.lng - to[1]) > threshold
    );
  };

  useEffect(() => {
    const ws = new WebSocket(`${process.env.REACT_APP_WS_URL}/ws/bus-tracking`);
    ws.onopen = () => {
      console.log("✅ WebSocket connected");
      ws.send(JSON.stringify({ action: "subscribe", channel: "BUS_TRACKING" }));
    };

    ws.onmessage = async (event) => {
      const message = JSON.parse(event.data);
      const { event_type, payload } = message;

      if (event_type === "bus_location") {
        const u = payload;
        const busId = u.bus_id;
        const newPos = [
          parseFloat(u.location?.latitude),
          parseFloat(u.location?.longitude),
        ];
        const marker = busRefs.current[busId];
        if (!marker || !marker.getLatLng) return;

        if (animationRefs.current[busId]) {
          cancelAnimationFrame(animationRefs.current[busId]);
        }

        const oldPos = marker.getLatLng();
        const nowTimestamp = Date.now();
        const lastTime = lastUpdateTimes.current[busId] || nowTimestamp - 1000;
        const duration = nowTimestamp - lastTime;
        lastUpdateTimes.current[busId] = nowTimestamp;

        if (isSignificantChange(oldPos, newPos)) {
          await animateMarker(oldPos, newPos, marker, duration, busId);
        }

        setBus((prevBuses) =>
          prevBuses.map((bus) =>
            bus.id === busId ? { ...bus, position: newPos } : bus
          )
        );
      }
    };

    ws.onerror = (err) => {
      console.error("❌ WebSocket error:", err);
    };

    ws.onclose = () => {
      console.log("⚠️ WebSocket closed");
    };
    return () => {
      ws.close();
    };
  }, []);

  const doZoom = () => {
    if (!mapInitialized) return;
    const map = mapRef.current;
    if (!map) return;
    // 1️⃣ First Load: Zoom to all filtered bus positions
    if (firstLoadRef.current) {
      firstLoadRef.current = false;
      setTimeout(() => {
        const validBusPositions = filteredBus
          .map((b) => b.position)
          .filter(
            (pos) =>
              Array.isArray(pos) &&
              typeof pos[0] === "number" &&
              typeof pos[1] === "number"
          );
        if (validBusPositions.length > 0) {
          const bounds = L.latLngBounds(validBusPositions);
          map.flyToBounds(bounds, { padding: [50, 50], duration: 1 });
        } else {
          map.setView([20.293, 85.818], 13);
          console.warn("No valid bus positions to zoom to.");
        }
      }, 0);
      return;
    }
    // 2️⃣ Zoom to selected bus
    if (selectedbus && selectedbus.value && Array.isArray(filteredBus)) {
      const matchedBus = filteredBus.find(
        (b) => String(b.id) === String(selectedbus.value)
      );

      if (matchedBus && Array.isArray(matchedBus.position)) {
        const [lat, lng] = matchedBus.position;
        if (typeof lat === "number" && typeof lng === "number") {
          map.invalidateSize();
          setTimeout(() => {
            map.flyTo([lat, lng], 17, { duration: 1 });
          }, 100);
          return;
        }
      }
      console.warn("No valid position for selected bus.");
      return;
    }
    // 3️⃣ Zoom to selected route
    if (selectedroute && filteredRoute?.length > 0) {
      const matchedRoute = filteredRoute.find(
        (r) => String(r.id) === String(selectedroute.value)
      );
      if (matchedRoute && Array.isArray(matchedRoute.polyline)) {
        const allCoords = matchedRoute.polyline
          .filter(
            ([lng, lat]) => typeof lat === "number" && typeof lng === "number"
          )
          .map(([lng, lat]) => L.latLng(lat, lng));

        if (allCoords.length > 0) {
          const bounds = L.latLngBounds(allCoords);
          if (bounds.isValid()) {
            map.flyToBounds(bounds, { padding: [20, 20], duration: 1 });
            return;
          }
        }
      }
      console.warn("Selected route has no valid path.");
      map.setView([20.293, 85.818], 13);
      return;
    }

    // 4️⃣ Default: Zoom to all filtered bus positions
    const validBusPositions = filteredBus
      .map((b) => b.position)
      .filter(
        (pos) =>
          Array.isArray(pos) &&
          typeof pos[0] === "number" &&
          typeof pos[1] === "number"
      );
    if (validBusPositions.length > 0) {
      const bounds = L.latLngBounds(validBusPositions);
      if (bounds.isValid()) {
        setTimeout(() => {
          map.flyToBounds(bounds, { padding: [50, 50], duration: 1 });
        }, 100);
        return;
      }
    }
    // Fallback to default location
    console.warn("No filtered buses to zoom to.");
    map.setView([20.293, 85.818], 13);
  };

  useEffect(() => {
    if (bus.length > 0 || route.length > 0) {
      doZoom();
    }
  }, [selectedbus, selectedroute, mapInitialized, filteredRoute]);

  useEffect(() => {
    if (!param.bus_id && !param.route_id && !param.trip_mode) {
      setFilteredRoute(route);
      setFilteredBus(bus);
      setFilteredStop(stop);
      return;
    }
    const filteredRoutes = route.filter((r) => {
      const matchroute = param.route_id ? r.id == param.route_id : true;
      const matchBus = param?.trip_mode
        ? bus
            .filter((b) => b.trip_mode == param.trip_mode)
            .map((b) => b.route_id)
            .includes(r.id)
        : true;
      return matchroute && matchBus;
    });
    const filteredStops = filteredRoutes.flatMap((r) =>
      (r.stops || []).map((s) => ({
        id: s?.stop?.id,
        name: s?.stop?.name,
        latitude: parseFloat(s.stop.latitude),
        longitude: parseFloat(s.stop.longitude),
      }))
    );
    const filteredBuses = bus.filter((b) => {
      const matchBus = param.bus_id ? b.id == param.bus_id : true;
      const matchRoute = param.route_id ? b.route_id == param.route_id : true;
      const matchTrip = param.trip_mode ? b.trip_mode == param.trip_mode : true;
      return matchBus && matchRoute && matchTrip;
    });
    setFilteredRoute(filteredRoutes);
    setFilteredStop(filteredStops);
    setFilteredBus(filteredBuses);
  }, [param, route]);

  const busPosition = bus.length ? bus[0].position : [20.2961, 85.8245];
  return (
    <div className="card" style={{ overflow: "hidden" }}>
      <div className="card-body p-0">
        {route.length > 0 || bus.length > 0 ? (
          <div
            ref={containerRef}
            style={{ height: isFullscreen ? "100vh" : "75vh", width: "100%" }}
          >
            <MapContainer
              center={busPosition}
              zoom={14}
              style={{ height: "100%", width: "100%" }}
              attributionControl={false}
            >
              <MapInitializer
                onMapReady={(mapInstance) => {
                  mapRef.current = mapInstance;
                  setMapInitialized(true);
                }}
              />
              <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
              {MapInitializer && (
                <button
                  onClick={toggleFullscreen}
                  title={isFullscreen ? "Exit Fullscreen" : "Enter Fullscreen"}
                  style={{
                    position: "absolute",
                    top: 15,
                    right: 15,
                    zIndex: 1000,
                    width: "40px",
                    height: "40px",
                    border: "none",
                    borderRadius: "50%",
                    backgroundColor: "white",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                  }}
                >
                  {isFullscreen ? (
                    <FiMinimize size={20} />
                  ) : (
                    <FiMaximize size={20} />
                  )}
                </button>
              )}
              {MapInitializer && (
                <button
                  title="Zoom In"
                  onClick={doZoom}
                  style={{
                    position: "absolute",
                    top: 70,
                    right: 15,
                    zIndex: 1000,
                    width: "40px",
                    height: "40px",
                    border: "none",
                    borderRadius: "50%",
                    backgroundColor: "rgba(29, 119, 255, 0.8)",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                  }}
                >
                  {isFullscreen ? (
                    <TbZoomScan size={20} style={{ color: "white" }} />
                  ) : (
                    <TbZoomScan size={20} style={{ color: "white" }} />
                  )}
                </button>
              )}
              {selectedroute &&
                filteredRoute.map((item, idx) => (
                  <Polyline
                    key={idx}
                    positions={item?.polyline.map(([lon, lat]) => [lat, lon])}
                    color="blue"
                    weight={4}
                  />
                ))}

              {filteredStops.map((stop, index) => (
                <Marker
                  key={`stop_${index}`}
                  position={[stop.latitude, stop.longitude]}
                  icon={getStopIcon}
                >
                  <Popup>
                    <span className="fw-semibold">{stop.name}</span>
                  </Popup>
                </Marker>
              ))}
              {filteredBus.length > 0 &&
                filteredBus.map((bus) => (
                  <Marker
                    key={bus.id}
                    position={bus.position ? bus.position : ""}
                    icon={
                      bus.trip_mode === "PICKUP"
                        ? pickupIcon
                        : bus.trip_mode == "DROP"
                        ? dropoffIcon
                        : unknownicon
                    }
                    ref={(ref) => {
                      if (ref) busRefs.current[bus.id] = ref;
                    }}
                  >
                    <Popup>
                      <div className="popup-content">
                        <div className="popup-header">
                          <FaBus className="popup-icon me-1" />
                          <b className="text-primary">{bus?.name}</b>
                          {/* <span
                            className={`ms-2 badge text-bg-${
                              bus?.delay === "0s"
                                ? "success-soft"
                                : "danger-soft"
                            }`}
                          >
                            {bus?.delay === "0s"
                              ? "On Time"
                              : `Delay: ${bus?.delay}`}
                          </span> */}
                        </div>
                        <div className="popup-details">
                          <FaRoute className="popup-icon me-1" />
                          <span>
                            {bus?.routeName} ({bus?.shift})
                          </span>
                        </div>
                        {bus?.schedule_arrival && (
                          <div className="popup-details">
                            <FaClock className="popup-icon me-1" />
                            Schedule Arrival:
                            <span className="badge text-bg-info-soft">
                              {convertToAMPM(bus?.schedule_arrival)}
                            </span>
                          </div>
                        )}
                        {bus?.actual_arrival && (
                          <div className="popup-details mt-1">
                            <FaClock className="popup-icon me-1" />
                            Actual Arrival:
                            <span className="badge text-bg-warning-soft">
                              {convertToAMPM(bus?.actual_arrival)}
                            </span>
                          </div>
                        )}
                      </div>
                    </Popup>
                  </Marker>
                ))}
            </MapContainer>
          </div>
        ) : (
          <div className="d-flex justify-content-center align-items-center p-3">
            <span className="text-danger">No data found</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default Trackmap;
